module.exports = __webpack_public_path__ + "img/pmicon.27e8f5a6.svg";